import { render, staticRenderFns } from "./ContestEntryItem.vue?vue&type=template&id=267821e9&scoped=true"
import script from "./ContestEntryItem.vue?vue&type=script&lang=ts"
export * from "./ContestEntryItem.vue?vue&type=script&lang=ts"
import style0 from "./ContestEntryItem.vue?vue&type=style&index=0&id=267821e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267821e9",
  null
  
)

export default component.exports